/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { CatalogPagination } from '../ui/CatalogPagination';

type Props = {
  itemCount: number;
  hasMore: boolean;
  loading?: boolean;
  loadingMore?: boolean;
  onLoadMore: () => void;
  listNouns: { singular: string; plural: string };
};

/** Pie de listas de historial en modales: resumen + «Siguiente» (mismo patrón que catálogo/stock). */
export function ModalHistoryListFooter({
  itemCount,
  hasMore,
  loading = false,
  loadingMore = false,
  onLoadMore,
  listNouns,
}: Props) {
  if (itemCount === 0 && !loading) return null;

  return (
    <CatalogPagination
      variant="infinite"
      catalogPageIndex={0}
      pageSize={Math.max(itemCount, 1)}
      catalogTotalCount={null}
      hasMore={hasMore}
      productsLoading={loading}
      productsLoadingMore={loadingMore}
      productCount={itemCount}
      onPreviousPage={() => {}}
      onNextPage={onLoadMore}
      listNouns={listNouns}
    />
  );
}
